import { Stack, StackProps, styled, Typography } from "@mui/material";

type ICourseStyle = {
  isCourse?: boolean;
}

export const TypographyCourseType = styled(Typography)<{ $isRTL?: boolean }>(({ $isRTL }) => ({
  borderLeft: $isRTL ? "0.1rem solid" : "none",
  borderRight: $isRTL ? "none" : "0.1rem solid",
  fontSize: "0.875rem",
  fontWeight: 500,
  lineHeight: "1.09375rem",
  marginLeft: $isRTL ? "0.2rem" : "0",
  marginRight: $isRTL ? "0" : "0.2rem",
  paddingLeft: $isRTL ? "0.4rem" : "0",
  paddingRight: $isRTL ? "0" : "0.4rem"
}));

export const CourseInfo = styled(Stack)(() => ({
  "& > div": {
    alignItems: "center",
    display: "flex",
    gap: "0.21875rem"
  },
  alignItems: "center",
  display: "flex",
  flexDirection: "row",
  height: "1.125rem",
  justifyContent: "space-between"
}));

export const CompletitionStatus = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between"

}));

export const TypographyContainer = styled("div")(({ theme }) => ({
  "> p": {
    color: theme.customColors.exploreCardText
  },
  width: "100%"

}));

export const RemainingTime = styled("div")(({ theme }) => ({
  background: theme.customColors.backgroundSecondary,
  borderRadius: "0.25rem",
  border: `1px solid ${theme.customColors.textTag}`,
  padding: "0.11rem 0.44rem"
}));

export const Course = styled("div")<StackProps & ICourseStyle>(({ theme, isCourse = true }) => ({
  "& > div": {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem"
  },
  "&:before": {
    background: isCourse ? theme.customColors.systemSecondary01 : theme.customColors.textWarning,
    borderRadius: "50rem",
    content: "''",
    marginRight: "0.5rem",
    width: "2px"
  },
  ":hover": {
    // background: theme.customColors.backgroundSecondaryHover, //TODO ripristinare,
    background: `rgba(${theme.customColors.backgroundSecondaryHover})`,
    cursor: "pointer"
  },
  borderRadius: "0.5rem",
  display: "flex",
  flexDirection: "row",
  gap: "0.5rem",
  margin: "0 0.5rem",
  padding: "0.5rem 0.5rem"
}));

export const TypographyWidget = styled(Typography)<
  StackProps & ICourseStyle & { $isRTL?: boolean }
>(({ theme, $isRTL }) => ({
  fontSize: "0.76875rem",
  fontWeight: "400",
  color: theme.customColors.exploreCardText,
  direction: $isRTL ? "rtl" : "ltr",
  lineHeight: "1.09375rem",
  width: $isRTL ? "100%" : "60%"
}));
